// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-1t8hh";
var _3 = "desktop_passenger-YLucc";
var _4 = "mobile_passenger-cO4qp";
var _5 = "recommended-1U7oC";
var _6 = "next-fxdu6";
var _7 = "slider-3MXPg";
export { _1 as "__esModule", _2 as "wrapper", _3 as "desktop_passenger", _4 as "mobile_passenger", _5 as "recommended", _6 as "next", _7 as "slider" }
export default { "__esModule": _1, "wrapper": _2, "desktop_passenger": _3, "mobile_passenger": _4, "recommended": _5, "next": _6, "slider": _7 }
